import { Button, Tooltip } from "antd";
import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { AddBankDetailsModal } from "./AddBankDetailsModal";
import { ReactComponent as PlusIcon } from "../../../images/plus.svg";
import { CustomButton } from "ui";

export const AddBankDetailsButton = observer(() => {
  const { actionModals } = useStores();

  const addBankDetailsHandler = () => {
    actionModals.open(() => <AddBankDetailsModal />, {
      width: "600px",
      noValidation: true,
      title: "Добавить реквизиты",
      isOverlayClose: false,
      onApply: () => {
        return Promise.resolve();
      },
    });
  };
  return (
      <CustomButton
        size="middle"
        icon={<PlusIcon />}
        onClick={addBankDetailsHandler}
      >
        Добавить
      </CustomButton>
  );
});
